

















import { Component, Prop, Vue } from "vue-property-decorator";
import store from "../store";

@Component
export default class Textarea extends Vue {
  data() {
    return {
      storeData: store.state
    };
  }
  addPrefix(level: number, isParentLastChild: boolean, isLastChild: boolean) {
    let prefix = "";
    const indent = "　　　";
    const hasParentIndent = "　┃　";
    const ruledLine = "　┣　";
    const ruledLineEnd = "　┗　";
    switch (level) {
      case 1:
        prefix = isLastChild ? ruledLineEnd : ruledLine;
        break;
      case 2:
        prefix =
          (isParentLastChild ? indent : hasParentIndent) +
          (isLastChild ? ruledLineEnd : ruledLine);
        break;
      default:
        break;
    }
    return prefix;
  }
  get text() {
    const branches = store.state.branches;
    let text = "";

    // Level 1
    branches.forEach((branch, index) => {
      text = text + branch.name + "\n";

      // Level 2
      branch.branches.forEach((branch2, index2) => {
        const isLastChild = branch.branches.length === index2 + 1;
        text =
          text + this.addPrefix(1, false, isLastChild) + branch2.name + "\n";

        // Level 3
        branch2.branches.forEach((branch3, index3) => {
          const isParentLastChild = branch.branches.length === index2 + 1;
          const isLastChild = branch2.branches.length === index3 + 1;
          text =
            text +
            this.addPrefix(2, isParentLastChild, isLastChild) +
            branch3.name +
            "\n";
        });
      });
    });

    return text;
  }
}
